import { appViewState } from "../store";
import { mutatorAction } from "satcheljs";

export default mutatorAction("SHOW_SHARE_WITHDRAW_DIALOG", function showShareWithdrawDialog(
    isWithdrawMode: boolean,
    show: boolean
) {
    appViewState().shareDialogViewState.withdrawMode = isWithdrawMode;
    appViewState().shareDialogViewState.dialogOpen = show;
});